import React from 'react';
import { SideBarItem, SideBarItemIcon, SideBarItemText } from './Data.styles';
import { IFileStatus } from 'utils/types';
import { getStatusIcon } from '../settings.utils';

export const FileTypeSideBarItem = ({
  application,
  link,
  isActive,
  status,
  text,
}: {
  application?: boolean;
  isActive: boolean;
  link: string;
  status: IFileStatus;
  text: string;
}) => {
  return (
    <SideBarItem to={link} active={isActive}>
      <SideBarItemText>{text}</SideBarItemText>
      <SideBarItemIcon>
        {getStatusIcon({
          status,
          isApplication: application,
          isActive: isActive,
        })}
      </SideBarItemIcon>
    </SideBarItem>
  );
};
